import React from 'react';
import TablePagination from '@material-ui/core/TablePagination';
import { withStyles } from '@material-ui/core/styles';
const TablePaginationComponent = withStyles({
  select: {
    border: '1px solid #ADADAD',
    borderRadius: '2px'
  }
})(TablePagination);
export const Pagination = ({
  handleChangePage,
  handleChangeRowsPerPage,
  pageNumber,
  totalElements,
  rowsPerEachPage
}) => {
  return /*#__PURE__*/React.createElement(TablePaginationComponent, {
    rowsPerPageOptions: [10, 25, 50, 100],
    component: "div",
    count: totalElements,
    page: pageNumber,
    labelDisplayedRows: ({
      page,
      count
    }) => `Page ${page + 1} of  ${Math.ceil(count / rowsPerEachPage) != 0 ? Math.ceil(count / rowsPerEachPage) : 1}`,
    rowsPerPage: rowsPerEachPage,
    onChangePage: handleChangePage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  });
};
export default TablePagination;